import React, { useState } from "react";
import {
  Image,
  ImageBackground,
  Linking,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { ids, styles } from "../landingPageCss";
import contactUsBackground from "../../../../assets/landingPage/contact_us/contactUsBackground.webp";
import contactUsIcon from "../../../../assets/landingPage/contact_us/icon.png";
import mobielIcon from "../../../../assets/landingPage/contact_us/mobile.png";
import messageIcon from "../../../../assets/landingPage/contact_us/message.png";

import instagramIcon from "../../../../assets/landingPage/contact_us/instagram.png";
import facebookIcon from "../../../../assets/landingPage/contact_us/fb.png";
import travelTriangleIcon from "../../../../assets/landingPage/contact_us/travelTriangle.png";
import wpIcon from "../../../../assets/landingPage/contact_us/wp.png";
import appstore from "../../../../assets/landingPage/contact_us/appstore.png";
// import playStore from "../../../../assets/landingPage/contact_us/playstore.webp";
import { TouchableRipple } from "react-native-paper";
import QuickLinkModal from "./QuickLinkModal";
import TermsCondition from "./QuickLinkComponent/TermsCondition";
import PrivacyPolicy from "./QuickLinkComponent/PrivacyPolicy";
import CancellationPolicy from "./QuickLinkComponent/CancellationPolicy";
import BusinessLaw from "./QuickLinkComponent/BusinessLaw";
import PersonalizedTripModal from "../../Personalized Trip/PersonalizedTripModal";

const ContactUs = () => {
  const [isVisibleQuickLinkModal, setIsVisibleQuickLinkModal] = useState(false);
  const [selectedQuickLink, setSelectedQuickLink] = useState(null);
  const [isVisiblePersonalizedTripModal, setIsVisiblePersonalizedTripModal] =
    useState(false);
  const quickLinkList = [
    {
      name: "Terms & Conditions",
      component: <TermsCondition />,
    },
    {
      name: "Privacy Policy",
      component: <PrivacyPolicy />,
    },
    {
      name: "Pricing Policy",
      component: <PrivacyPolicy />,
    },
    {
      name: "Cancellation and Refund Policy",
      component: <CancellationPolicy />,
    },
    {
      name: "Business Description & Usecase",
      component: <BusinessLaw />,
    },
  ];
  const socialMediaList = [
    {
      name: "instagram",
      url: "https://www.instagram.com/maroonmigrates/",
      image: instagramIcon,
    },
    {
      name: "facebook",
      url: "ttps://www.facebook.com/MaroonMigrates/",
      image: facebookIcon,
    },
    {
      name: "travel_triangle",
      url: "https://traveltriangle.com/agents/3630373131322d4d6172-maroon-migrates/",
      image: travelTriangleIcon,
    },
    {
      name: "whatsapp",
      url: "https://api.whatsapp.com/send?phone=9099445588&text=Hello",
      image: wpIcon,
    },
    {
      name: "apple",
      url: "https://apps.apple.com/vn/app/maroon-migrates/id6476488471",
      image: appstore,
    },
  ];
  const handlePress = (url) => {
    Linking.openURL(url);
  };
  return (
    <ImageBackground resizeMode="cover" source={contactUsBackground}>
      <View
        style={styles.contact_us_container}
        dataSet={{ media: ids.contact_us_container }}
        id="contact_us"
      >
        <View
          style={styles.contactUsTextContainer}
          dataSet={{ media: ids.contactUsTextContainer }}
        >
          <Image source={contactUsIcon} style={styles.ContactUSIcon} />
          <Text style={styles.contacUsText}>Contact Us</Text>
        </View>
        <View
          style={styles.contact_us_subContainer}
          dataSet={{ media: ids.contact_us_subContainer }}
        >
          {/* left container */}
          <View
            style={styles.contactLeftContainer}
            dataSet={{ media: ids.contactLeftContainer }}
          >
            <Text style={styles.contact_headerText}>
              <Text style={{ fontSize: 22 }}>Quick Links</Text>
            </Text>
            {quickLinkList?.map((quickLink, index) => (
              <React.Fragment key={index}>
                <TouchableRipple
                  key={index}
                  onPress={() => {
                    setIsVisibleQuickLinkModal(true);
                    setSelectedQuickLink(quickLink.name);
                  }}
                >
                  <Text style={styles.contact_link_text}>{quickLink.name}</Text>
                </TouchableRipple>

                {isVisibleQuickLinkModal &&
                selectedQuickLink === quickLink.name ? (
                  <QuickLinkModal
                    visible={isVisibleQuickLinkModal}
                    handleClose={() => setIsVisibleQuickLinkModal(false)}
                    title={quickLink.name}
                    component={quickLink.component}
                  />
                ) : null}
              </React.Fragment>
            ))}

            <Text style={styles.contact_link_text}></Text>
          </View>
          {/* Right container */}
          <View
            style={styles.contactRightContainer}
            dataSet={{ media: ids.contactRightContainer }}
          >
            <View
              style={styles.socialMediaContainer}
              dataSet={{ media: ids.socialMediaContainer }}
            >
              <Image source={mobielIcon} style={styles.socialMediaIcon} />
              <Text style={styles.socialMediaText}>079 460 406 66</Text>
            </View>
            <View
              style={styles.socialMediaContainer}
              dataSet={{ media: ids.socialMediaContainer }}
            >
              <Image source={messageIcon} style={styles.socialMediaIcon} />
              <Text style={styles.socialMediaText}>
                contact@maroonmigrates.com
              </Text>
            </View>
            <View
              style={[styles.socialMediaContainer, { marginTop: 30 }]}
              dataSet={{ media: ids.socialMediaContainer }}
            >
              <Text style={styles.socialMediaText}>Follow Us on</Text>
            </View>
            <View
              style={styles.socialMediaContainer}
              dataSet={{ media: ids.socialMediaContainer }}
            >
              {socialMediaList?.map((socialMedia, _index) => (
                <TouchableOpacity
                  key={_index}
                  activeOpacity={0.8}
                  onPress={() => handlePress(socialMedia?.url)}
                >
                  <Image
                    source={socialMedia.image}
                    style={styles.socialMediaIcon}
                  />
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>
      </View>
      {isVisiblePersonalizedTripModal ? (
        <PersonalizedTripModal
          visible={isVisiblePersonalizedTripModal}
          handleClose={() => {
            setIsVisiblePersonalizedTripModal(false);
          }}
        />
      ) : null}
    </ImageBackground>
  );
};

export default ContactUs;
